module.exports = __webpack_public_path__ + "static/iPhone-5e040b75bd69aad7fec19a84dfaacc66.png";